var React = require('react');

function CleanBurgerMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"BurgerMenu"},[React.createElement("rect",{"id":"Top","x":"21","y":"35","width":"214","height":"32","rx":"16","fill":"#000000","key":0}),React.createElement("rect",{"id":"Mid","x":"21","y":"115","width":"214","height":"32","rx":"16","fill":"#000000","key":1}),React.createElement("rect",{"id":"Bot","x":"21","y":"195","width":"214","height":"32","rx":"16","fill":"#000000","key":2})]));
}

CleanBurgerMenu.defaultProps = {"width":"256","height":"256","viewBox":"0 0 256 256","fill":"none"};

module.exports = CleanBurgerMenu;

CleanBurgerMenu.default = CleanBurgerMenu;
